@if (!showViewMode) {
  <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
    class="component-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [for]="HTML_ID"
          [ngClass]="{'small': isSmallLabel}">
          <span [attr.data-cy]="labelCypressTag">{{label}}</span>
        </label>
      }
      @if (hasWarningStar) {
        <app-warning-star
          [attr.data-cy]="warningStarCypressTag"
        [type]="warningLevel"></app-warning-star>
      }
      <div class="label-information">
        <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
      </div>
    </div>
    @if (formattedSectionText) {
      <div class="static-section-wrapper" [ngClass]="emptySectionCss" data-cy="dropdown-static-section">
        <label class="static-section-label">{{formattedSectionText}}</label>
      </div>
    }
    <div [attr.data-cy]="inputWrapperCypressTag"
      [ngClass]="{'invalid': !isValid, 'focus': isFocused, 'disabled': isDisabled, 'alternate-background': alternateBackground}"
      class="input-wrapper">
      <app-tooltip [disable]="inputHasEllipsis" [dynamic]="false" [message]="inputFormatter(tooltipText)">
        <input #dropdown="ngbTypeahead"
          (blur)="inputBlur.emit($event)"
          (click)="inputClick.emit($event)"
          (focus)="inputFocus.emit($event)"
          (keydown)="inputKeyDown.emit($event)"
          (mouseenter)="toggleTooltip($event)"
          [attr.data-cy]="textInputCypressTag"
          [formControlName]="FORM_CONTROL_NAME"
          [id]="HTML_ID"
          [inputFormatter]="inputFormatter"
          [ngStyle]="inputHeight"
          [ngbTypeahead]="search"
          [placeholder]="placeholder"
          [resultTemplate]="resultTemplate"
          (focusin)="$event.stopPropagation()"
          class="text-ellipsis input"
          type="text">
      </app-tooltip>
      <div class="icon-wrapper">
        @if (hasDeleteButton) {
          <button (click)="deleteInputValue()"
            [attr.data-cy]="deleteButtonCypressTag"
            class="input-button">
            <span [class]="deleteButtonIconClass"></span>
          </button>
        }
        <button (click)="inputFocus.emit($event)"
          [attr.data-cy]="dropdownButtonCypressTag"
          [disabled]="isInputDisabled"
          class="input-button">
          <span [class]="getDropdownButtonIconClass($safeNavigationMigration(dropdown?.isPopupOpen()))"></span>
        </button>
      </div>
    </div>
    @if (showMessages) {
      @for (message of messages | anyKeyValue; track message) {
        @if (message.value.length > 0) {
          <app-warning-inline
            [warningInlineLabelsArray]="message.value"
          [warningType]="message.key"></app-warning-inline>
        }
      }
    }
  </div>
} @else {
  <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [ngClass]="{'small': isSmallLabel}">
          <span [attr.data-cy]="labelCypressTag">{{label}}</span>
        </label>
      }
      <div class="label-information">
        <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
      </div>
    </div>
    <div [attr.data-cy]="inputWrapperCypressTag" class="input-wrapper view-mode">
      @if (resultFormatter == null) {
        <span>{{initialValue}}</span>
      } @else {
        <span [attr.data-cy]="inputValueCypressTag">{{resultFormatter(initialValue)}}</span>
      }
    </div>
  </div>
}

<ng-template #resultTemplate let-result="result" let-term="term">
  <app-tooltip [message]="resultFormatter(result)">
    <ngb-highlight [result]="resultFormatter(result)" [term]="term" [highlightClass]="dropdownTextNotBold"></ngb-highlight>
  </app-tooltip>
</ng-template>

